<template>
    <div class="container">
        <div>开通{{ payWay === 10  ? '微信' : '支付宝'}}收款</div>
        <apply-for-activation v-if="activeStep === 1"/>
        <merchant-authentication v-else/>
    </div>
</template>

<script>
    import applyForActivation from './common/applyForActivation';
    import merchantAuthentication from './common/merchantAuthentication';
    export default {
        name: "openingCollection",
        components:{applyForActivation,merchantAuthentication},
        data(){
            return{
                activeStep:0,
                payWay:'',//微信 10 ；支付宝 20
            }
        },
        mounted() {
            this.payWay = Number(this.$route.query.payWay);
            this.activeStep = Number(this.$route.query.activeStep);
        }


    }
</script>

<style scoped lang="scss">

</style>